export const muiCheckboxOverrides = {
	styleOverrides: {
		root: ({ theme }) => {
			return {
				color: `${theme.palette.tsGoColor.greenDark} !important`,
			};
		},
	},
};
